/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Big_Vivid_Hamster_StirInputs */

const en_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment is still pending. Click "Complete payment" to visit Stripe (the payment provider) and finish your purchase.`)
};

const id_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran masih tertunda. Klik "Selesaikan pembayaran" untuk membuka Stripe (penyedia pembayaran) dan selesaikan pembelian Anda.`)
};

const ms_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayaran anda masih belum selesai. Klik "Lengkapkan bayaran" untuk melawat Stripe (penyedia pembayaran) dan selesaikan pembelian anda.`)
};

const ca_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El teu pagament encara no s'ha efectuat. Fes clic a "Completar pagament" per anar a Stripe (la plataforma de pagament) i finalitzar la teva compra.`)
};

const cs_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše platba stále není vyřízena. Kliknutím na tlačítko „Dokončit platbu“ navštivte službu Stripe (poskytovatel plateb) a nákup dokončete.`)
};

const da_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din betaling afventer stadig. Klik på "Gennemfør betaling" for at gå til Stripe (betalingsudbyderen) og afslutte dit køb.`)
};

const de_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Zahlung ist noch nicht abgeschlossen. Klicke auf „Zahlung abschließen“, um zu Stripe (dem Zahlungsanbieter) zu gelangen und deinen Kauf abzuschließen.`)
};

const et_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie makse on veel pooleli. Makseteenuse osutaja Stripe külastamiseks ja ostu lõpetamiseks klõpsake „Lõpeta makse“.`)
};

const es_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu pago todavía está pendiente. Haz clic en “Completar pago” para ir a Stripe (el proveedor de pagos) y completar la compra.`)
};

const fr_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre paiement n’a pas encore été effectué. Cliquez sur Finaliser le paiement pour accéder à la plateforme de paiement Stripe et terminer votre achat.`)
};

const hr_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše je plaćanje još uvijek na čekanju. Kliknite „Dovrši plaćanje” da biste išli na Stripe (pružatelja usluga plaćanja) i dovršili kupnju.`)
};

const it_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo pagamento è ancora in sospeso. Fai clic su "Completa pagamento" per visitare la pagina di Stripe (il provider di pagamento) e completare il tuo acquisto.`)
};

const lv_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu maksājums vēl tiek apstrādāts. Klikšķiniet uz pogas “Pabeigt maksājumu”, lai dotos uz Stripe (maksājumu pakalpojumu sniedzējs) un pabeigtu pirkumu.`)
};

const lt_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsų mokėjimas vis dar apdorojamas. Spustelėkite mygtuką „Užbaigti mokėjimą“, kad eitumėte į „Stripe“ (mokėjimo paslaugų teikėjas) ir užbaigtumėte pirkimą.`)
};

const hu_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fizetése függőben van. Kattintson a „Fizetés befejezése” gombra, hogy a Stripe (a fizetési szolgáltató) oldalára lépjen, és véglegesítse a vásárlást.`)
};

const nl_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De betaling is nog niet verricht. Klik op 'Betaling voltooien' om naar Stripe (de betalingsprovider) te gaan en de aankoop af te ronden.`)
};

const nb_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalingen mangler fremdeles. Trykk på «Fullfør betalingen» for å gå til Stripe og gjennomføre kjøpet.`)
};

const pl_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja płatność wciąż oczekuje na realizację. Kliknij „Dokończ płatność”, aby przejść do Stripe (dostawca płatności) i dokończyć zakup.`)
};

const pt_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O seu pagamento está pendente. Clique em "Realizar pagamento" para acessar a plataforma Stripe (o provedor de pagamento) e concluir sua compra.`)
};

const ro_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plata ta este încă în așteptare. Fă clic pe „Finalizare plată” pentru a vizita Stripe (furnizorul de plăți) și a finaliza achiziția.`)
};

const sk_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša platba stále čaká na spracovanie. Kliknutím na tlačidlo „Dokončiť platbu“ navštívte spoločnosť Stripe (poskytovateľa platieb) a dokončite svoj nákup.`)
};

const sl_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše plačilo je še vedno na čakanju. S klikom na »Zaključi plačilo« obiščite ponudnika plačil Stripe in dokončajte nakup.`)
};

const fi_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksusi on edelleen vireillä. Napsauta "Suorita maksu loppuun" siirtyäksesi Stripeen (maksupalvelun tarjoaja) ja viimeistelläksesi ostoksesi.`)
};

const sv_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din betalning pågår fortfarande. Klicka på "Slutför betalning" för att besöka Stripe (betalningsleverantören) och avsluta ditt köp.`)
};

const vi_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản thanh toán của bạn vẫn đang chờ xử lý. Bấm vào "Hoàn tất thanh toán" để truy cập Stripe (nhà cung cấp dịch vụ thanh toán) và hoàn tất giao dịch của bạn.`)
};

const tr_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödemeniz hala beklemede. Stripe'ı (ödeme sağlayıcısı) ziyaret etmek ve satın alma işleminizi tamamlamak için "Ödemeyi tamamla"ya tıklayın.`)
};

const el_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η πληρωμή σας εκκρεμεί ακόμη. Κάντε κλικ στο «Ολοκλήρωση πληρωμής» για να επισκεφθείτε το Stripe (τον πάροχο πληρωμών) και να ολοκληρώσετε την αγορά σας.`)
};

const bg_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Твоето плащане все още е в изчакване. Кликни върху „Завърши плащането“, за да посетиш Stripe (доставчика на плащания) и да финализираш покупката си.`)
};

const ru_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш платеж всё ещё находится в ожидании. Нажмите «Завершить оплату», чтобы перейти в Stripe (платёжный провайдер) и завершить покупку.`)
};

const sr_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша уплата је још увек на чекању. Кликните на „Обави плаћање“ да бисте посетили Stripe (пружаоца услуга плаћања) и обавили куповину.`)
};

const uk_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш платіж все ще очікує на обробку. Натисніть "Завершити оплату", щоб перейти до Stripe (платіжного провайдера) і завершити покупку.`)
};

const ka_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი გადახდა ჯერ კიდევ პროცესშია. დააჭირეთ „გადახდის დასრულებას“, რომ Stripe-ზე (გადახდის პროვაიდერი) გადახვიდეთ და ყიდვა დაასრულოთ.`)
};

const hi_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी पेमेंट अभी भी पेंडिंग है। Stripe (पेमेंट प्रोवाइडर) पर जा कर "कम्पलीट पेमेंट" पर क्लिक करें और अपना परचेस पूरा करें।`)
};

const th_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การชำระเงินของคุณยังอยู่ระหว่างดำเนินการ กรุณาคลิก "ชำระเงินให้เสร็จสิ้น" เพื่อไปยัง Stripe (ผู้ให้บริการชำระเงิน) และดำเนินการซื้อให้เสร็จสมบูรณ์`)
};

const ko_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제가 아직 보류 중입니다. '결제 완료'를 클릭하여 Stripe(결제 서비스 제공업체)를 방문하여 구매를 완료하세요.`)
};

const zh_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的付款仍在等待处理。请点击“完成付款”以访问 Stripe （付款提供商）并完成您的购买。`)
};

const zh_tw_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的付款狀態仍為待處理。請點擊「完成付款」前往 Stripe（付款服務供應商）完成購買流程。`)
};

const ja_big_vivid_hamster_stir = /** @type {(inputs: Big_Vivid_Hamster_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払いはまだ保留中です。「支払いを完了する」をクリックして、Stripe（支払いプロバイダー）にアクセスし、購入を完了してください。`)
};

/**
* | output |
* | --- |
* | "Your payment is still pending. Click \"Complete payment\" to visit Stripe (the payment provider) and finish your purchase." |
*
* @param {Big_Vivid_Hamster_StirInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const big_vivid_hamster_stir = /** @type {((inputs?: Big_Vivid_Hamster_StirInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Big_Vivid_Hamster_StirInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_big_vivid_hamster_stir(inputs)
	if (locale === "ms") return ms_big_vivid_hamster_stir(inputs)
	if (locale === "ca") return ca_big_vivid_hamster_stir(inputs)
	if (locale === "cs") return cs_big_vivid_hamster_stir(inputs)
	if (locale === "da") return da_big_vivid_hamster_stir(inputs)
	if (locale === "de") return de_big_vivid_hamster_stir(inputs)
	if (locale === "et") return et_big_vivid_hamster_stir(inputs)
	if (locale === "es") return es_big_vivid_hamster_stir(inputs)
	if (locale === "fr") return fr_big_vivid_hamster_stir(inputs)
	if (locale === "hr") return hr_big_vivid_hamster_stir(inputs)
	if (locale === "it") return it_big_vivid_hamster_stir(inputs)
	if (locale === "lv") return lv_big_vivid_hamster_stir(inputs)
	if (locale === "lt") return lt_big_vivid_hamster_stir(inputs)
	if (locale === "hu") return hu_big_vivid_hamster_stir(inputs)
	if (locale === "nl") return nl_big_vivid_hamster_stir(inputs)
	if (locale === "nb") return nb_big_vivid_hamster_stir(inputs)
	if (locale === "pl") return pl_big_vivid_hamster_stir(inputs)
	if (locale === "pt") return pt_big_vivid_hamster_stir(inputs)
	if (locale === "ro") return ro_big_vivid_hamster_stir(inputs)
	if (locale === "sk") return sk_big_vivid_hamster_stir(inputs)
	if (locale === "sl") return sl_big_vivid_hamster_stir(inputs)
	if (locale === "fi") return fi_big_vivid_hamster_stir(inputs)
	if (locale === "sv") return sv_big_vivid_hamster_stir(inputs)
	if (locale === "vi") return vi_big_vivid_hamster_stir(inputs)
	if (locale === "tr") return tr_big_vivid_hamster_stir(inputs)
	if (locale === "el") return el_big_vivid_hamster_stir(inputs)
	if (locale === "bg") return bg_big_vivid_hamster_stir(inputs)
	if (locale === "ru") return ru_big_vivid_hamster_stir(inputs)
	if (locale === "sr") return sr_big_vivid_hamster_stir(inputs)
	if (locale === "uk") return uk_big_vivid_hamster_stir(inputs)
	if (locale === "ka") return ka_big_vivid_hamster_stir(inputs)
	if (locale === "hi") return hi_big_vivid_hamster_stir(inputs)
	if (locale === "th") return th_big_vivid_hamster_stir(inputs)
	if (locale === "ko") return ko_big_vivid_hamster_stir(inputs)
	if (locale === "zh") return zh_big_vivid_hamster_stir(inputs)
	if (locale === "zh-tw") return zh_tw_big_vivid_hamster_stir(inputs)
	if (locale === "ja") return ja_big_vivid_hamster_stir(inputs)
	return en_big_vivid_hamster_stir(inputs)
});